import { useEffect, useState } from "react"
import { formatDate, parseDate } from "../Helpers"

interface Props {
    value: string
    onBlur: (date: string) => void
    disabled: boolean
}
const DateInput = (props: Props) => {
    const {value, onBlur, disabled = false} = props

    const [displayValue, setDisplayValue] = useState(formatDate(value) || '')

    useEffect(() => setDisplayValue(formatDate(value) || ''), [value])

    const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
        const stringValue = e.target.value
        onBlur(parseDate(stringValue))
    }
    return <div className="amount-input">
        <input
            type="string"
            placeholder="28/02/2024"
            value={displayValue}
            onChange={(e) => setDisplayValue(e.target.value)}
            onBlur={handleBlur}
            disabled={disabled}/>
    </div>
}

export default DateInput